import { useNavigate } from "react-router-dom";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import DealsShowcaseComponent from "../components/DealsShowcaseComponent";
import ProductShowcaseComponent from "../components/ProductShowcaseComponent";
import ShortProductOne from "../components/ShortProductOne";
import ShippingOne from "../components/ShippingOne";
import ColorInit from "../helper/ColorInit";
import CardSkeleton from "../components/Skeletons/CardSkeleton";
import BannerSkeleton from "../components/Skeletons/BannerSkeleton";
import useHomeStore from "../components/ZustandStore/useHomeStore";
import DynamicMetaTags from "../helper/DynamicMetaTags";
import { GET_HOME_API } from "../app/constants";
const HomePageOne = () => {
  const navigate = useNavigate();

  // Zustand store states
  const { banners, productData, fourSalesCard, handleAddToCart } =
    useHomeStore();

  // Handle product click
  const handleProductClick = (product) => {
    console.log("Product clicked:", product);
    navigate(`/product/${product.slug}`);
  };

  // Handle Add to Cart

  // Filter flash sale collections
  const flashSaleCollections = productData?.filter(
    (collection) => collection.title === "Flash Sale"
  );

  return (
    <>
      {/* SEO Setup */}
      <DynamicMetaTags endpoint={`${GET_HOME_API}`} />

      {/* Color initialization */}
      <ColorInit color={false} />

      {/* Main Content */}
      {banners.length === 0 ? (
        <BannerSkeleton />
      ) : (
        <BannerOne banners={banners} />
      )}

      <div className="px-40">
        {/* Shipping Section */}
        <ShippingOne />

        {/* Flash Sale Section with Skeleton Loader */}
        {flashSaleCollections?.length > 0 ? (
          flashSaleCollections.map((collection) => (
            <ProductShowcaseComponent
              slug={collection.slug}
              key={collection.id}
              title={collection.title}
              description={collection.metaDescription || "Loading..."}
              productList={collection.products || []}
              onProductClick={handleProductClick}
              handleAddToCart={handleAddToCart}
            />
          ))
        ) : (
          <CardSkeleton />
        )}
        {/* Short Products Section */}
        <ShortProductOne
          fourSalesCard={fourSalesCard}
          handleAddToCart={handleAddToCart}
        />
        {/* Featured and Trending Products */}
        {productData?.length === 0 || !productData ? (
          <CardSkeleton />
        ) : (
          productData.map((collection) => {
            if (
              collection.title === "Featured Products" ||
              collection.title === "Trending Products" ||
              collection.title === "Top Selling Products"
            ) {
              return (
                <ProductShowcaseComponent
                  slug={collection.slug}
                  key={collection.id}
                  title={collection.title}
                  productList={collection.products || []}
                  onProductClick={handleProductClick}
                  handleAddToCart={handleAddToCart}
                />
              );
            }

            return null;
          })
        )}
        {/* Other Components */}
        <DealsShowcaseComponent />
        <FeatureOne />
      </div>
    </>
  );
};

export default HomePageOne;
